<div class="wizard-container">
  <h2>Anticipos</h2>

  <div class="step-content">
    <h3>Formato de Datos</h3>
    <div class="radio-options">
      <label class="radio-item">
        <input
          type="radio"
          name="tipolista"
          value="detallado"
          (click)="modos(0)"
          [checked]="SwDetal"
        />
        <span>Detallado</span>
      </label>
      <label class="radio-item">
        <input
          type="radio"
          name="tipolista"
          value="totales"
          (click)="modos(1)"
          [checked]="SwTotal"
        />
        <span>Totales</span>
      </label>
    </div>
  </div>

  <div class="step-content">
    <h3>Límites de Fechas</h3>
    <div class="date-input-group">
      <input
        class="date-input"
        placeholder="Desde dd/mm/yyyy"
        name="d1"
        [(ngModel)]="prifec"
        ngbDatepicker
        #d1="ngbDatepicker"
      />
      <button class="btn-calendar" (click)="d1.toggle()" type="button">
        <fa-icon [icon]="icoFec"></fa-icon>
      </button>
    </div>
    <div class="date-input-group">
      <input
        class="date-input"
        placeholder="Hasta dd/mm/yyyy"
        name="d2"
        [(ngModel)]="ultfec"
        ngbDatepicker
        #d2="ngbDatepicker"
      />
      <button class="btn-calendar" (click)="d2.toggle()" type="button">
        <fa-icon [icon]="icoFec"></fa-icon>
      </button>
    </div>
  </div>

  <div class="step-content text-center">
    <button class="btn btn-cave" (click)="listado()">
      <fa-icon [icon]="icoVal"></fa-icon> Listar
    </button>
  </div>

  <div class="loading" *ngIf="resul">
    <div class="spinner"></div>
  </div>
</div>
